import ApiService from "@/core/services/ApiService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface Report {
  report: unknown;
}

export interface Reports {
  report: Report;
}

@Module
export default class ReportsModule extends VuexModule implements Reports {
  report = {} as Report;

  /**
   * Get current Report object
   * @returns Report
   */
  get currentReport(): Report {
    return this.report;
  }

  @Mutation
  [Mutations.SET_REPORT](Report) {
    this.report = Report;
  }

  @Action
  async [Actions.GET_REPORTS](info) {
    try {
      const response = await ApiService.get(
        `project/${info.projectId}/reports` + info.params
      );
      return Promise.resolve(response);
    } catch (error) {
      this.context.dispatch(Actions.API_ERROR_MESSAGE, error);
      return Promise.reject(error);
    }
  }

  @Action
  async [Actions.DOWNLOAD_REPORT](reportId) {
    try {
      const response = await ApiService.get(`report/${reportId}/download`);
      return Promise.resolve(response);
    } catch (error) {
      this.context.dispatch(Actions.API_ERROR_MESSAGE, error);
      return Promise.reject(error);
    }
  }

  @Action
  async [Actions.GENERATE_NEW_REPORT](data) {
    try {
      const response = await ApiService.post("report/", data);
      return Promise.resolve(response);
    } catch (error) {
      this.context.dispatch(Actions.API_ERROR_MESSAGE, error);
      return Promise.reject(error);
    }
  }
}
